<template>
  <span>
    <label>{{ label }}</label>
    <el-select
      v-if="dropdownUms.length > 0"
      v-model="selectedUM"
      :placeholder="uniTranslation('UM')"
    >
      <el-option
        v-for="item in dropdownUms"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      ></el-option>
    </el-select>
  </span>
</template>

<script>
import { Select, /*Input,*/ Option } from "element-ui";
import umService from "../../services/backend/umService";

export default {
  name: "FluidUmSelector",
  components: { "el-select": Select, "el-option": Option },
  props: {
    value: {
      type: String,
      default: ""
    },
    category: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    }
  },
  data() {
    return { dropdownUms: [] };
  },
  computed: {
    selectedUM: {
      get() {
        return this.value;
      },
      set(val) {
        /*if (!val) val = 0;
        this.handleInput(val);*/
        this.changeSelectedUM(val);
      }
    }
  },
  watch: {
    category: function(nv, ov) {
      var that = this;
      if (nv != ov && "" + nv != "") {
        umService.getUms(nv).then(function(data) {
          data.forEach(element => {
            if (element.descrizione != "K") {
              that.dropdownUms.push({
                value: element.id,
                label: element.descrizione,
                decimals: element.decimals
              });
            }
          });
        });
      }
    }
  },
  mounted: function() {
    var that = this;
    umService.getUms(that.category).then(function(data) {
      data.forEach(element => {
        if (element.descrizione != "K") {
          that.dropdownUms.push({
            value: element.id,
            label: element.descrizione,
            decimals: element.decimals
          });
        }
      });
    });
  },
  methods: {
    changeSelectedUM(e) {
      this.$emit("input", e);
    }
  }
};
</script>

<style lang="scss">
/*
$input-height: 30px;
.form-control {
  padding: 0px;
  border-radius: 5px;
  height: $input-height !important;

  &.auto-numeric {
    padding: 0 5px;
    text-align: center;
  }
}*/
</style>
